<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style scoped>
.image-wrap-add-edit {
  width: 160px;
  height: 80px;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex: 160px 0 0;
  background: none !important;
}

.attendee-form-wrap .con-slot-tabs {
  padding: 0 100px;
}


@media screen and (min-width: 1367px) and (max-width: 1440px) {
  .attendee-form-wrap .con-slot-tabs {
    padding: 0 0px;
  }
  
}
</style>
<template>
  <div id="sponsor-edit-tab-account">
    <div class="tab-top-part">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/1 w-full mb-5">
        <!-- <h3>Session Type - {{session_data.SessionTypeDetails.TypeName}}</h3> -->
        <div class="custom-head-wrap">
          <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
              <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->

          <input
            type="text"
            class="w-full"
            id="sponsorName"
            v-validate="'required'"
            name="Sponsor Name"
            placeholder="Sponsor Name*"
            v-model="data_local.Name"
          />
          <span class="text-danger text-sm" v-show="errors.has('Sponsor Name')"
            >This field is required</span
          >
        </div>
      </div>
      <div class="vx-col md:w-6/12 w-full mb-4">
        <div
          class="border-1 image-wrap-area"
        >
          <div class="flex items-center flex-col sm:flex-row">
            <div class="image-wrap-add-edit mt-2 mr-3">
              <img :src="imgSrc" class="" />
            </div>
            <div>
              <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
              <input
                type="file"
                class="hidden"
                ref="update_avatar_input"
                @change="update_avatar($event, '500x250')"
                accept="image/*"
              />
              <vs-button
                class="mr-4 mb-4"
                @click="$refs.update_avatar_input.click()"
                >Upload</vs-button
              >
              <!-- <vs-button type="border" color="danger">Remove Logo</vs-button> -->
            </div>
            
          </div>
          <p class="reco-text-spo">High quality image: 2160x1080px (2:1 ratio)</p>
        </div>
      </div>
      <div class="vx-col md:w-3/12 w-full mt-2">
        <label>Email</label>
        <vs-input
          class="inputx w-full"
          name="Email"
          v-model="data_local.Email"
          v-validate="'email'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{
          errors.first("Email")
        }}</span>
      </div>
      <div class="vx-col md:w-3/12 w-full mt-2">
        <label>Phone No</label>
        <vs-input
          class="inputx w-full"
          name="Phone"
          v-model="data_local.Phone"
          v-validate="'numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Phone')">{{
          errors.first("Phone")
        }}</span>
      </div>
    </div>
    <!-- Content Row -->
    <div class="vx-row">
      <!-- <div class="vx-col md:w-1/3 w-full mt-2">
        <label>
          Sponsor Name
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Sponsor Name"
          v-model="data_local.Name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Sponsor Name')">{{
          errors.first("Sponsor Name")
        }}</span>
      </div> -->

      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>Mapped Contacts</label>
        <v-select
          multiple
          :closeOnSelect="false"
          v-model="data_local.MappedContacts"
          label="Name"
          :options="attendessList"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
      </div>
      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>Booth No</label>
        <vs-input
          class="inputx w-full"
          name="BoothNo"
          v-model="data_local.BoothNo"
        />
      </div>
      <!--<div class="vx-col md:w-1/3 w-full mt-2">
        <label>Resources</label>
        <v-select multiple :closeOnSelect="false" v-model="data_local.Resources" label="Name" :options="attendessList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />  
      </div>-->
      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>Level</label>
        <vs-input
          class="inputx w-full"
          name="Level"
          v-model="data_local.Level"
        />
      </div>
      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>Website</label>
        <vs-input
          class="inputx w-full"
          name="Website"
          v-validate="'url:require_protocol'"
          v-model="data_local.Website"
        />
        <span class="text-danger text-sm" v-show="errors.has('Website')">{{
          errors.first("Website")
        }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>Category</label>
        <!-- <vs-input class="inputx w-full" name="Category" v-model="data_local.Category" /> -->
        <div class="category-wrap">
          <v-select
            class="track-select w-full mr-2"
            name="CategoryName"
            label="CategoryName"
            v-model="data_local.Category"
            :options="CategoryList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <vs-button
            color="primary"
            type="filled"
            @click="popupCategoryActive = true"
            class="category-butn"
            style="margin-top: 0px; float: right"
            >Add</vs-button
          >
        </div>
        <vs-popup
          class="holamundo sponsor-category-add-popup"
          title="Add New Category"
          :active.sync="popupCategoryActive"
        >
          <div class="add-track-inner-section">
            <div class="vx-row w-full">
              <div class="vx-col md:w-10/12 w-full">
                <label>Category:-</label>
                <vs-input class="inputx input-track-name w-full" v-model="CategoryName"/>
              </div>
              <div class="vx-col md:w-2/12">
                <label>Color:-</label>
                <input type="color" v-model="CategoryColor" @change="CategoryColor"/>
              </div>
              
            </div>
            <div class="vx-row w-full">
              <div class="vx-col md:w-1/1 w-full mt-5">
                <div class="w-full">
                  Logo Size : -
                  <vs-radio
                    v-model="LogoSize"
                    class="ml-3"
                    checked="true"
                    vs-value="1X"
                    name="LogoSize"
                    >Small (1X)</vs-radio
                  >
                  <vs-radio
                    v-model="LogoSize"
                    class="ml-3"
                    vs-value="2X"
                    name="LogoSize"
                    >Medium (2X)</vs-radio
                  >
                  <vs-radio
                    v-model="LogoSize"
                    class="ml-3"
                    vs-value="3X"
                    name="LogoSize"
                    >Large (3X)</vs-radio
                  >
                </div>
              </div>
            </div>
            
            <br />
            <vs-button color="rgb(76, 139, 246)" type="filled" @click="addCategory"
              >Add Category</vs-button
            >
          </div>
        </vs-popup>
      </div>
      <!--<div class="vx-col md:w-1/1 w-full mt-2">
        <label>Resources </label>
        <div class="vx-col md:w-1/1 w-full mt-2" v-for="file in data_local.Resources">
        <a :href="file">File</a>
        </div>

       <input type="file" multiple class="hidden" ref="update_resource_input" @change="upload_resources" accept=".csv.excel,.xlsx,.pdf,.doc,.docx">
            <vs-button class="mr-4 mb-4" @click="$refs.update_resource_input.click()">Upload Resources</vs-button>
      </div>-->
      <div class="vx-col md:w-1/1 w-full mt-2">
        <label>Profile</label>
        <!-- <vs-textarea class="inputx w-full" name="Profile" v-model="data_local.Profile" v-validate="'required'"/> -->
        <div class="profile-edit">
          <!-- <quill-editor v-model="data_local.Profile" name="Profile" /> -->
          <ckeditor
            class="desc-event"
            v-model="data_local.Profile"
            :config="editorConfig"
          ></ckeditor>
        </div>
      </div>
    </div>

    <!-- <div class="countDivder vx-col md:w-1/1 w-full">
        <vs-divider> Social Links </vs-divider>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Facebook</label>
          <div class="mt-2">
            <vs-input class="inputx w-full" name="Facebook" v-model="data_local.SocialLinks.Facebook" v-validate="'required'"/>
          </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Twitter</label>
          <div class="mt-2">
            <vs-input class="inputx w-full" name="Twitter" v-model="data_local.SocialLinks.Twitter" v-validate="'required'"/>
          </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4">
          <label>GooglePlus</label>
          <div class="mt-2">
            <vs-input class="inputx w-full" name="GooglePlus" v-model="data_local.SocialLinks.GooglePlus" v-validate="'required'"/>
          </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4">
          <label>LinkedIn</label>
          <div class="mt-2">
            <vs-input class="inputx w-full" name="LinkedIn" v-model="data_local.SocialLinks.LinkedIn" v-validate="'required'"/>
          </div>
      </div>
    </div>-->
    </div>
    <div class="tab-botttom-sticky-part">
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="mt-2" @click="$router.push('/event/sponsors')"
            >Back To List</vs-button
          >
          <vs-button
            class="ml-auto mt-2"
            @click="before_save(true)"
            :disabled="!validateForm"
            color="success"
            >Save & Continue</vs-button
          >
          <vs-button
            class="ml-4 mt-2"
            @click="before_save(false)"
            :disabled="!validateForm"
            color="success"
            >Save & Exit</vs-button
          >
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="reset_data"
            >Reset</vs-button
          >
        </div>
      </div>
    </div>
    </div>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";

import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleSponsorManagement from "@/store/sponsor-management/moduleSponsorManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";

export default {
  components: {
    vSelect,
    quillEditor,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      CategoryName: "",
      CategoryColor: "",
      LogoSize: "1X",
      CategoryList: [],
      popupCategoryActive: false,
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc: this.data.Logo,
      attendessList: [],
      ResourceFiles: [],
      editorConfig: CKconfig.editorConfig,
      imageRatio: 2 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "2 / 1",
      popupCropper: false
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    croppedImagePath(blob) {
      this.imgSrc = blob;
      this.popupCropper = false;
    },
    before_save(form_continue = false) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes(form_continue);
        }
      });
    },
    addCategory() {
      /* eslint-disable */
      if (!this.CategoryName) return;

      this.$vs.loading();
      this.$store
        .dispatch("sponsorManagement/addSponsorCategory", {
          CategoryName: this.CategoryName,
          CategoryColor: this.CategoryColor,
          LogoSize: this.LogoSize,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Sponsor Category",
            text: res.message,
          });
          this.$vs.loading.close();
          if (res.status == 200) {
            this.CategoryName = "";
            this.popupCategoryActive = false;
            this.fetch_sponsorCategory();
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    fetch_sponsorCategory() {
      this.$store
        .dispatch("sponsorManagement/fetchSponsorCategoryDropdown")
        .then((res) => {
          this.CategoryList = res;
          console.log(res);
        });
    },
    upload_resources(input) {
      if (input.target.files.length) {
        for (var i = 0; i < input.target.files.length; i++) {
          const file = input.target.files[i];
          const metadata = {
            contentType: file.type,
          };
          //console.log(file)
          let filename = file.name;
          filename = filename.split(".").pop();
          //console.log(filename)
          const validImageTypes = [
            "csv",
            "pdf",
            "xlsx",
            "excel",
            "doc",
            "docx",
          ];
          if (!validImageTypes.includes(filename)) {
            alert("Only files allowed.");
            return false;
          }
          this.data_local.Resources.push(file.webkitRelativePath);
          this.ResourceFiles.push(file);
        }
      }
    },
    update_avatar(input, fileWH) {
      // You can update avatar Here
      let vm = this;
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);

        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.popupCropper = true;
          //  vm.imgSrc = e.target.result;
            vm.data_local.file = file;
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes(form_continue = false) {
      /* eslint-disable */
      if (!this.validateForm) return;

      this.$vs.loading();
      this.data_local.Logo = this.imgSrc;
      this.data_local.ResourceFiles = this.ResourceFiles;
      this.ResourceFiles = [];
      const Id = this.$route.params.sponsorId;
      //alert(Id);
      if (Id) {
        this.$store
          .dispatch("sponsorManagement/updateSponsor", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Sponsor",
              text: "Sponsor updated successfully.",
            });
            this.$vs.loading.close();
            if (form_continue) this.$emit("activateTab", 1);
            else this.$router.push("/event/sponsors/");
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.$store
          .dispatch("sponsorManagement/addSponsor", { data: this.data_local })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Sponsor",
              text: "Sponsor created successfully.",
            });
            this.$vs.loading.close();
            if (res.status == 200) {
              if (form_continue) {
                this.$router.push({
                  name: "sponsor-edit",
                  params: {
                    sponsorId: res.Id,
                  },
                });
              } else this.$router.push("/event/sponsors/");
            }
          })
          .catch((err) => {
            //console.error(err)
          });
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc = this.data.Logo;
    },
    //////
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        //this.attendessList = res;
        //console.log(res);
        for (let i = 0; i < res.length; i++) {
          this.attendessList.push({
            AttendeeId: res[i].AttendeeId,
            Company: res[i].Company,
            Designation: res[i].Designation,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone,
            ProfilePictureURL: res[i].ProfilePictureURL,
          });
        }
      });
    },
  },
  created() {
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    this.getAttendees();
    this.fetch_sponsorCategory();
  },
};
</script>
